<div class="region-market-inline" *ngIf="regionData.length">
    <div class="region-market-pill" [class.is-readonly]="readonly" role="group"
        [attr.aria-label]="readonly ? 'Selected region and market' : 'Region and market selector'">
        <div class="pill-item pill-region" [title]="readonly ? 'Region' : 'Select region'">
            <!-- <mat-icon class="pill-icon" aria-hidden="true">public</mat-icon> -->
            <img src="../../../assets/icons/icon-region.svg" width="14" height="14" title="Region" />
            <app-select class="compact-field" [formControl]="regionSelectFormControl" [field]="regionField"
                [disabled]="isRegionListDisabled">
            </app-select>
        </div>

        <div class="pill-divider" aria-hidden="true"></div>

        <div class="pill-item pill-market" [title]="readonly ? 'Market' : 'Select markets'">
            <!-- <mat-icon class="pill-icon" aria-hidden="true">place</mat-icon> -->
            <img src="../../../assets/icons/icon-market.svg" width="14" height="14" title="Market" />
            <app-select class="compact-field" [formControl]="marketSelectFormControl" [field]="marketField"
                [multiple]="true" [disabled]="readonly">
            </app-select>
        </div>
    </div>
</div>